/* eslint-disable @typescript-eslint/camelcase */
import { CariSTTApiRepository } from "@/app/infrastructures/repositories/api/CariSTTApiRepository";
import { SearchSttFilter } from "@/data/payload/api/CariSttApiRequest";
import { SearchSttJsonRequestInteface } from "@/data/payload/contracts/CariSttRequest";
import {
  CariSttEntities,
  CariSttRequest,
  DetailSttScan,
  SearchSttList,
  SearchSttScan
} from "@/domain/entities/ListCariSTT";
import { injectable } from "tsyringe";

@injectable()
export class ListCariSTTPresenter {
  private repository: CariSTTApiRepository;

  constructor(repository: CariSTTApiRepository) {
    this.repository = repository;
  }

  public getListCariSTT(params: CariSttRequest): Promise<CariSttEntities> {
    return this.repository.getListCariSTT(params);
  }

  public getDownloadListCariSTT(id: number): Promise<any> {
    return this.repository.getDownloadCariSTTList(id);
  }

  public getDetailSttScan(id: number): Promise<DetailSttScan> {
    return this.repository.getDetailSttScan(id);
  }

  public searchSttScan(
    payload: SearchSttJsonRequestInteface
  ): Promise<SearchSttScan> {
    return this.repository.searchSttScan(payload);
  }

  public searchSttManifest(): Promise<DetailSttScan> {
    return this.repository.searchSttManifest();
  }

  public getSearchSttScanList(params: SearchSttFilter): Promise<SearchSttList> {
    return this.repository.getSearchSttScanList(params);
  }
}
